// This base url is required to enable branch support. i.e
// For master: inspection/basic/29843983271983721/thank-you
// For branches: inspection/basic/__CFE-999/29843983271983721/thank-you

import { generateFunnelPath } from '@wkda/funnel-utils';

const routes =
  require(`${process.env.RAZZLE_ROOT_APP_PATH}/src/routes.js`).default;

/**
 * @typedef {import('@wkda/internal-types').ISelfEvaluationAppConfig} ISelfEvaluationAppConfig
 */

/**
 * @typedef {import('@wkda/internal-types').IBookingAppConfig} IBookingAppConfig
 */

/**
 * @typedef {import('@wkda/internal-types').ICarleadCreationAppConfig} ICarleadCreationAppConfig
 */

/**
 * @param {ISelfEvaluationAppConfig | IBookingAppConfig | ICarleadCreationAppConfig} config
 */
export function buildRoutes(config) {
  const generated = routes.map(({ path, ...rest }) => {
    return {
      ...rest,
      path: path ? `${generateFunnelPath(config)}${path}` : undefined,
    };
  });

  return generated;
}
